import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';

type PropsType = {
  title: string;
  children: ReactNode;
};

const AccountConfigLayout = ({ children, title }: PropsType) => {
  const subOptions = [
    { label: 'Google', url: '/calender-settings' },
    { label: 'Microsoft', url: '/calender-settings/microsoft' },
  ];

  const location = useLocation();
  return (
    <SettingsPageLayout
      title={title}
      indexOptions={[{ label: 'Select Account', url: location.pathname, subOptions: subOptions }]}
      breadCrumnbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.APPS_AND_INTEGRATION,
        Pages['CALENDER']
      )}
    >
      {children}
    </SettingsPageLayout>
  );
};

export default AccountConfigLayout;
